<template>
  <div class="config-configurable-pages f-w f-h">
    <div class="f-h config-configurable-pages__wrapper">
      <IntCheckbox
        v-if="company"
        v-model="company.allowCfgTemplateFromTeam"
        class="config-configurable-pages__allow-tmp"
        :title="$t('message.CFG_PAGE_ALLOW_TEAM_CREATING_TEMPLATE')"
        @input="setParams"
      />
      <ConfigurablePagesList
        ref="pagesList"
        :key="keyModifier"
        class="config-configurable-pages__list"
        @pageClick="displayEditablePage"
      />
    </div>
    <Modal :value="$route.query.pageId > 0 && company" fullscreen @input="onModalInput">
      <ConfigurablePage cfg-template-edition :display-gw-widgets="company && company.accessGW === 1" />
    </Modal>
  </div>
</template>

<script>
/**
 * Page to display all the configurable pages templates of this company.
 */

import { isEqual } from 'lodash';
// Components
import ConfigurablePage from '@/views/overlay/configurable-page.vue';
import ConfigurablePagesList from '@/components/configurable-pages-list.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
import Modal from '@/components/modal.vue';
// Mixins
import mixinConfigPages from '@/mixins/config-pages.vue';
// Utils
import { SET_COMPANY_PARAM } from '@/store/modules/config/action-types';

export default {

  name: 'ConfigConfigurablePages',

  components: {
    ConfigurablePage,
    ConfigurablePagesList,
    IntCheckbox,
    Modal,
  },

  mixins: [mixinConfigPages],

  data() {
    return {
      keyModifier: 1,
      allEditableParams: [
        'allowCfgTemplateFromTeam',
      ],
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.CFG_PAGES'),
    };
  },

  methods: {
    refresh() {
      // Refresh pages after checkLogin
      if (this.$refs.pagesList && this.$refs.pagesList.refresh) {
        this.$refs.pagesList.refresh();
      }
    },
    /** Set company params */
    setParams() {
      const params = {};
      this.allEditableParams.forEach((param) => {
        params[param] = this.company[param];
      });
      this.$store.dispatch(`config/${SET_COMPANY_PARAM}`, params);
    },
    /** Handle a click on a page element in the list */
    displayEditablePage(page) {
      const query = Object.assign({}, this.$route.query);
      query.pageId = page.id;
      query.editable = true;
      if (!isEqual(query, this.$route.query)) {
        this.$router.replace({ query });
      }
    },
    /** Handle click on close button */
    onModalInput(show) {
      if (!show) {
        this.$router.replace({ query: {} });
        this.keyModifier++;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.config-configurable-pages {

  &__wrapper {
    display: flex;
    flex-flow: column;
  }

  &__allow-tmp {
    flex: 0 0 auto;
    margin-top: 1rem;
    margin-left: 1rem;
  }

  &__list {
    flex: 1;
    min-height: 0px;
  }
}
</style>
